import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance.js";
import { useEffect, useRef, useState } from "react";
import { MdDeleteForever } from "react-icons/md";
import { BiSolidEditAlt } from "react-icons/bi";
import Loader from "../../common/Loader/index.js";
import { saveAs } from "file-saver";
import { RiFilter2Fill } from "react-icons/ri";
import { KanbanBoard } from "../../common/KanbanBoard/index.jsx";
import CloseLostModal from "./CloseLostModel.js";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { notify, Toast } from "../../common/Toast/index.js";
import Model from "../../common/Model/index.js";
import formatDateIndian from "../../common/formatDateIndian.js";
import { IoPrintSharp } from "react-icons/io5";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import Filter from "../../common/Filter/index.js";
import { BsFileEarmarkPdfFill } from "react-icons/bs";

const stageMapping = {
  1: "Active",
  2: "Close Won",
  3: "Close Lost",
  6: "In-Production",
  7: "Complete",
  8: "In-Coating",
};

const stageID = {
  Active: 1,
  "Close Won": 2,
  "Close Lost": 3,
  "In-Production": 6,
  Complete: 7,
  "In-Coating": 8,
};

const MaterialQuotation = () => {
  const permission = getUserMenuPermission(10);
  const navigate = useNavigate();
  const [isMaterialQuotationData, setIsMaterialQuotationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterBtnRef = useRef(null);
  const [selectedCard, setSelectedCard] = useState();
  const [isCustomer, setIsCustomer] = useState({});
  const [openMenuCard, setOpenMenuCard] = useState(null);
  const [isCloseLostModalOpen, setIsCloseLostModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [salePersons, setSalePersons] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({
    proformaNo: "",
    customerName: "",
    salePerson: "",
    invoice_Creation: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    proformaNo: "",
    customerName: "",
    salePerson: "",
    invoice_Creation: "",
  });
  const userId = sessionStorage.getItem("userId");
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [selectedProformaForInvoice, setSelectedProformaForInvoice] =
    useState(null);
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [pdfModalUrl, setPdfModalUrl] = useState(null);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const location = useLocation();
  const filteredData = location?.state?.filteredData || [];
  const isFilteredFromDashboard =
    location.state?.isFilteredFromDashboard || false;
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      if (
        location.state?.isFilteredFromDashboard &&
        Array.isArray(location.state?.filteredData)
      ) {
        const transformed = filteredData?.map((item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "material-quotation",
        }));
        setIsMaterialQuotationData(transformed);
        setLoading(false);
      } else {
        fetchData();
      }
      setInitialized(true);
    }
  }, [initialized, location.state]);

  const columns = [
    "Active",
    "Close Won",
    "In-Production",
    "In-Coating",
    "Complete",
    "Close Lost",
  ];

  const toggleMenu = (quotationNo) => {
    setOpenMenuCard((prev) => (prev === quotationNo ? null : quotationNo));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".menu-container")) {
        setOpenMenuCard(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isFilteredFromDashboard) {
      fetchData();
    }
  }, [appliedFilters]);

  useEffect(() => {
    const fetchSalePersons = async () => {
      try {
        const res = await axiosInstance.get("User/GetAllUser");
        const salesData = res.data.map((person) => ({
          sale_Person_Id: Number(person.sale_Person_Id),
          Sale_Person_Name: person.Sale_Person_Name,
        }));

        setSalePersons(salesData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSalePersons();
  }, []);

  const handleCardMove = (card, newStage, oldStageId) => {
    const currentStageID = Number(oldStageId);
    const newStageID = stageID[newStage];

    if (currentStageID === 1 && (newStageID === 2 || newStageID === 3)) {
      setSelectedCard(card);
      newStageID === 2
        ? handleUpdateStage(card, newStage)
        : setIsCloseLostModalOpen(true);
    } else if (currentStageID === 2) {
      setSelectedCard(card);
      if (newStageID === 6) {
        handleUpdateStage(card, newStage);
      } else if (newStageID === 3) {
        setIsCloseLostModalOpen(true);
      }
    } else if (currentStageID === 6 && newStageID === 8) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 8 && newStageID === 7) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 7) {
      notify("Cannot move cards from Complete stage.");
    } else if (currentStageID === 3 && newStageID === 1) {
      handleUpdateStage(card, newStage);
    } else {
      notify(
        `Invalid move from ${stageMapping[currentStageID]} to ${stageMapping[newStageID]}`
      );
    }
  };

  const handleUpdateStage = async (card, newStage) => {
    try {
      setLoading(true);
      await axiosInstance.post("MaterialQuotation/AllUpdateProformaStage", {
        proforma_No: card,
        stage_Id: stageID[newStage],
      });
      fetchData();
    } catch (error) {
      notify("Error updating stage:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseLostSave = async (reason) => {
    try {
      setLoading(true);
      await axiosInstance.post("MaterialQuotation/SaveCloseLostProforma", {
        proforma_No: selectedCard,
        Reason: reason,
      });
      fetchData();
    } catch (error) {
      notify("Error saving Close Lost:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    setAppliedFilters({ ...filters });
    setIsFilterOpen(false);
  };

  const clearFilters = () => {
    setFilters({
      proformaNo: "",
      customerName: "",
      salePerson: "",
      invoice_Creation: "",
    });
    setAppliedFilters({
      proformaNo: "",
      customerName: "",
      salePerson: "",
      invoice_Creation: "",
    });
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const hasFilters = Object.values(appliedFilters).some(
        (val) => val.trim() !== ""
      );

      const [materialRes, customerRes] = await Promise.all([
        axiosInstance.post("MaterialQuotation/GetAllMaterialQuotations", {
          PageNumber: 1,
          PageSize: 10,
          Proforma_No: appliedFilters.proformaNo
            ? Number(appliedFilters.proformaNo)
            : null,
          customer_Id: appliedFilters.customerName || null,
          sale_Person_Id: hasFilters
            ? appliedFilters.salePerson
              ? Number(appliedFilters.salePerson)
              : null
            : Number(userId),
          invoice_Creation:
            appliedFilters.invoice_Creation === ""
              ? null
              : appliedFilters.invoice_Creation === "true",
        }),
        axiosInstance.get("Customer/GetAll"),
      ]);

      const transformedData = (materialRes.data.quotations || []).map(
        (item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "material-quotation",
          invoice_Creation:
            item.invoice_Creation === true ||
            item.invoice_Creation === 1 ||
            item.invoice_Creation === "true" ||
            item.invoice_Creation === "True",
        })
      );

      setIsMaterialQuotationData(transformedData);
      const customerMap = (customerRes.data || []).reduce((acc, cus) => {
        acc[cus.customer_Id] = cus.customer_Name;
        return acc;
      }, {});

      setIsCustomer(customerMap);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (proforma_No) => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetMaterialQuotationById/${proforma_No}`
      );
      navigate("/quotes/material-quotation/material-Details", {
        state: { materialQuotationData: data },
      });
      fetchData();
    } catch (error) {
      console.error("Error fetching site details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(
        `MaterialQuotation/DeleteMaterialQuotation/${selectedId}`
      );
      setAppliedFilters({ ...appliedFilters });
      notify("MaterialQuotation deleted successfully!", "error");
    } catch (err) {
      notify("Error deleting error:", err);
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handlePrint = async (proforma_No) => {
    try {
      setLoading(true);

      const quotation = isMaterialQuotationData.find(
        (item) => item.proforma_No === proforma_No
      );

      const customerName = isCustomer?.[quotation?.customer_Id] || "Customer";

      const safeCustomerName = customerName.replace(/\s+/g, "_");

      const response = await axiosInstance.get(
        `MaterialQuotation/materialQuotePrint/${proforma_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `PI_${proforma_No}_${safeCustomerName}.pdf`);
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing material quotation:", error);
      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const salePersonOptions = [
    ...salePersons.map((sp) => ({
      value: sp.sale_Person_Id.toString(),
      label: sp.Sale_Person_Name,
    })),
  ];

  const customerOptions = Object.entries(isCustomer).map(([id, name]) => ({
    value: id,
    label: name,
  }));

  const filterFields = [
    {
      label: "Proforma No",
      name: "proformaNo",
      type: "text",
      placeholder: "Search site name",
    },
    {
      label: "Sales Person",
      name: "salePerson",
      type: "select",
      options: salePersonOptions,
    },

    {
      label: "Customer Name",
      name: "customerName",
      type: "select",
      options: customerOptions,
    },
    {
      label: "Invoice Done",
      name: "invoice_Creation",
      type: "select",
      options: [
        { label: "All", value: "" },
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
      ],
    },
  ];

  const renderCard = (card) => {
    const stageOptions = {
      1: ["Close Won", "Close Lost"],
      2: ["In-Production", "Close Lost"],
      6: ["In-Coating"],
      8: ["Complete"],
      7: [],
      3: ["Active"],
    };
    const salePersonName =
      salePersons.find(
        (sp) => Number(sp.sale_Person_Id) === Number(card.sale_Person_Id)
      )?.Sale_Person_Name || "-";

    const getInitials = (name) => {
      if (!name) return "";
      const words = name.trim().split(" ");
      return words
        .slice(0, 2)
        .map((w) => w.charAt(0).toUpperCase())
        .join("");
    };

    const initials = getInitials(salePersonName);
    return (
      <>
        <div className="relative rounded-lg bg-white shadow-md p-4 border border-gray-2 mt-4 hover:shadow-lg transition duration-200 cursor-pointer ">
          <div
            key={card.proforma_No}
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData("cardId", card.proforma_No?.toString());
              e.dataTransfer.setData("stageId", card.stage_Id.toString());
            }}
          >
            <div className="flex justify-between items-center ">
              <p className="text-lg font-semibold text-primary">
                # {card.proforma_No}
              </p>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMenu(card.proforma_No);
                }}
                className="text-gray-700 hover:text-black"
              >
                <HiOutlineDotsVertical className="w-5 h-5" />
              </button>
            </div>
            <div
              className={`cursor-pointer`}
              onClick={() => handleEdit(card.proforma_No)}
            >
              <p className="text-md font-semibold text-primary">
                {isCustomer[card.customer_Id] || "Customer Name Not Found"}
              </p>
              <p className="text-sm font-medium">₹{card.net_Amount}</p>
              <p className="text-sm font-medium">{salePersonName}</p>
              <div className="flex items-center justify-between mt-2 border-t border-primary pt-2">
                <p className="text-sm font-medium">
                  {formatDateIndian(card.proforma_Date)}
                </p>
                <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold">
                  {initials}
                </div>
              </div>
            </div>
            {card.stage_Id === 7 && (
              <div className="mt-3 flex items-center gap-2">
                <input
                  type="checkbox"
                  id={`invoice-${card.proforma_No}`}
                  checked={Boolean(card.invoice_Creation)}
                  onChange={(e) => {
                    const isCreating = e.target.checked;
                    if (isCreating) {
                      setSelectedProformaForInvoice(card.proforma_No);
                      setIsInvoiceModalOpen(true);
                    }
                  }}
                  className="accent-primary h-4 w-4"
                />

                <label
                  htmlFor={`invoice-${card.proforma_No}`}
                  className="text-sm font-medium text-gray-700"
                >
                  Invoice Done
                </label>
              </div>
            )}

            {openMenuCard === card.proforma_No && (
              <div className="absolute right-0 top-[22%] w-32 bg-white border shadow-md rounded-md z-9999">
                {permission.isUpdate && (
                  <button
                    onClick={() => handleEdit(card.proforma_No)}
                    className="w-full flex items-center gap-3 text-left px-4 py-2 text-gray-700 hover:bg-gray-200"
                  >
                    <BiSolidEditAlt /> Edit
                  </button>
                )}

                <button
                  onClick={() => handlePrint(card.proforma_No)}
                  className="w-full flex items-center gap-3 text-left px-4 text-gray-700 hover:bg-gray-200"
                >
                  <IoPrintSharp /> Print
                </button>

                {permission.isDelete && (
                  <button
                    onClick={() => handleDelete(card.proforma_No)}
                    className="w-full flex items-center gap-3 text-left px-4 py-2 text-danger hover:bg-gray-200"
                  >
                    <MdDeleteForever /> Delete
                  </button>
                )}

                {card.stage_Id === 7 && card.invoice_Pdf && (
                  <button
                    // onClick={() => {
                    //   setPdfModalUrl(card.invoice_Pdf);
                    //   setIsPdfModalOpen(true);
                    // }}
                    onClick={() => {
                      if (card.invoice_Pdf) {
                        window.open(card.invoice_Pdf, "_blank");
                      } else {
                        notify("No PDF URL found.");
                      }
                    }}
                    className="w-full flex items-center gap-3 text-left px-4 py-2 text-primary"
                  >
                    <BsFileEarmarkPdfFill /> View Pdf
                  </button>
                )}

                <div className="border-b" />

                {stageOptions[card.stage_Id]?.map((option) => (
                  <button
                    key={option}
                    onClick={() =>
                      handleCardMove(card.proforma_No, option, card.stage_Id)
                    }
                    className="w-full flex items-center gap-2 text-left px-4 py-1 text-gray-700 hover:bg-gray-200"
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handleInvoiceUpload = async () => {
    if (!invoiceFile) {
      notify("Please select a PDF file");
      return;
    }

    const formData = new FormData();
    formData.append("Proforma_No", selectedProformaForInvoice);
    formData.append("Invoice_Pdf", invoiceFile);

    try {
      const response = await axiosInstance.post(
        "MaterialQuotation/SaveInvoicePdf",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const uploadedUrl = response?.data?.invoice_Pdf;

      setIsMaterialQuotationData((prev) =>
        prev.map((item) =>
          item.proforma_No === selectedProformaForInvoice
            ? {
                ...item,
                invoice_Creation: true,
                invoice_Pdf: uploadedUrl,
              }
            : item
        )
      );

      notify("Invoice uploaded successfully", "success");

      setIsInvoiceModalOpen(false);
      setInvoiceFile(null);
      fetchData();
    } catch (err) {
      console.error(err);
      notify("Error uploading invoice PDF");
    }
  };

  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-9999">
            <Loader />
          </div>
        )}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          {permission.isInsert && (
            <button
              className="rounded px-4 text-white py-2 w-full sm:w-auto bg-gray-300 cursor-not-allowed"
              onClick={() =>
                navigate("/quotes/material-quotation/material-Details")
              }
              disabled
            >
              + Add New PI
            </button>
          )}
          <button
            ref={filterBtnRef}
            className="flex items-center gap-2 bg-gray-200 px-3 py-2 rounded-md"
            onClick={() => setIsFilterOpen((prev) => !prev)}
          >
            <RiFilter2Fill className="text-lg text-primary" />
            Filter
          </button>
        </div>

        <Filter
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          filterFields={filterFields}
          filters={filters}
          setFilters={setFilters}
          applyFilters={applyFilters}
          clearFilters={clearFilters}
        />

        <div className="h-full">
          <KanbanBoard
            columns={columns}
            cards={isMaterialQuotationData}
            onCardMove={handleCardMove}
            renderCard={renderCard}
          />
          <CloseLostModal
            isOpen={isCloseLostModalOpen}
            onClose={() => setIsCloseLostModalOpen(false)}
            onSave={handleCloseLostSave}
          />
        </div>
      </div>
      <Model
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <div className="p-4 text-center">
          <p className="text-lg font-semibold mb-4">
            Are you sure you want to delete this site?
          </p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-gray-5 px-4 py-2 rounded-md"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="bg-danger text-white px-4 py-2 rounded-md"
              onClick={handleConfirmDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Model>
      <Model
        isOpen={isInvoiceModalOpen}
        onClose={() => setIsInvoiceModalOpen(false)}
        name=" Upload Invoice PDF"
      >
        <div className="p-4">
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setInvoiceFile(e.target.files[0])}
            className="mb-4 block w-full text-sm border border-gray-300 rounded-md p-2"
          />

          <div className="flex justify-end gap-3 mt-6">
            <button
              className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md"
              onClick={() => {
                setIsInvoiceModalOpen(false);
                setInvoiceFile(null);
              }}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-primary text-white rounded-md"
              onClick={handleInvoiceUpload}
            >
              Upload
            </button>
          </div>
        </div>
      </Model>
      <Model
        isOpen={isPdfModalOpen}
        onClose={() => {
          setPdfModalUrl(null);
          setIsPdfModalOpen(false);
        }}
        name="View Invoice PDF"
      >
        <div className="w-full h-[80vh]">
          {pdfModalUrl ? (
            <iframe
              src={pdfModalUrl}
              title="Invoice PDF"
              className="w-full h-full border"
            />
          ) : (
            <p className="text-center mt-10">No PDF available.</p>
          )}
        </div>
      </Model>
    </>
  );
};

export default MaterialQuotation;
